import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { OrderComponent } from './order/order.component';
import { RegisterComponent } from './register/register.component';
import { RequestComponent } from './request/request.component';
import { CommonComponent } from './layout/common/common.component';
import { UserResolver } from './shared/index';
import { AuthGuard } from './core/auth.guard';

const routes: Routes = [
  { path: '', redirectTo: 'order', pathMatch: 'full' },
  { path: 'login', component: LoginComponent, canActivate: [AuthGuard] },
  { path: 'register', component: RegisterComponent, canActivate: [AuthGuard] },
  {
    path: '',
    component: CommonComponent,
    children: [
      { path: '', redirectTo: 'order', pathMatch: 'full' },
      { path: 'order', component: OrderComponent,  resolve: { data: UserResolver}},
      { path: 'requests', component: RequestComponent,  resolve: { data: UserResolver}},
    ]
  }
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes, { useHash: false });
